import Animation from './Animation';

export default class Spell extends Animation {

	constructor (master) {

		super(master, 2000);
	}

	run () {

	}
}


// WEBPACK FOOTER //
// ./src/game/view/animation/Spell.js